<template>
  <div class="add" @keyup.13="submit">
    <mu-dialog title="新增客户" width="500" :open="open" @close="close">
      <mu-form :model="form" label-position="left" label-width="80" ref="form">
        <!-- <mu-form-item prop="userName" label="用户名">
          <mu-text-field v-model="form.userName"></mu-text-field>
        </mu-form-item> -->

        <mu-form-item prop="realName" label="真实姓名">
          <mu-text-field v-model.trim="form.realName"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="company" label="公司">
          <mu-text-field v-model.trim="form.company"></mu-text-field>
        </mu-form-item>

        <!-- <mu-form-item prop="type" label="用户类型">
          <mu-radio value="员工" v-model="form.type" label="员工"></mu-radio>
          <mu-radio value="客户" v-model="form.type" label="客户"></mu-radio>
          <mu-radio value="管理员" v-model="form.type" label="管理员"></mu-radio>
        </mu-form-item> -->

        <mu-form-item prop="phone" label="手机号">
          <mu-text-field v-model.number="form.phone"></mu-text-field>
        </mu-form-item>

        <!-- <mu-form-item prop="role" label="角色">
          <mu-select v-model="form.role.id" @change="roleChange">
            <mu-option v-for="(item,index) in roleList" :key="index" :label="item.name" :value="item.id"></mu-option>
          </mu-select>
        </mu-form-item> -->
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        userName: '',
        realName: '',
        phone: '',
        // 客户的roleId
        role: {
          id: 4
        },
        type: '客户',
        company: ''
      },
      roleList: []
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.user.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                userName: '',
                realName: '',
                phone: '',
                // 客户的roleId
                role: {
                  id: 4
                },
                type: '客户',
                company: ''
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  },
  watch: {
    'form.realName': {
      handler(val) {
        this.form.userName = val
      }
    }
  }
}
</script>

<style lang="less" scoped>
.add {
}
</style>



// WEBPACK FOOTER //
// src/views/customer/create.vue